module.exports = __webpack_public_path__ + "media/27.1a2ff701.mp3";